<template>
  <VuePerfectScrollbar class="search-list">
    <div v-for="(searches, day, index) in groupedSearches"
        class="day"
        :key="index">
      <div class="day-header">
        <div class="day-name">
          {{ day | relativeTimeInDays(2) | capitalize }}
        </div>
      </div>

      <ul class="day-search-list">
        <search-list-item v-for="(search, index) in searches"
                          :key="index"
                          :item="search" />
      </ul>
    </div>
    <base-scroll-to-top />
  </VuePerfectScrollbar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import SearchListItem from './SearchListItem.vue'

  export default {
    props: {
      searches: {
        type: Array,
        required: true
      }
    },

    components: {
      SearchListItem,
      VuePerfectScrollbar
    },

    computed: {
      groupedSearches() {
        return _.groupBy(
          this.searches,
          // transform the date string to milliseconds of the beginning of the day
          // "2021-02-01T00:01:00.000Z" => 1611964800000 (milliseconds)
          search => +new Date(search.time.slice(0, 10))
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-list {
    height: 100%;
    position: relative;
    padding-bottom: 70px;

    .day-header {
      display: flex;
      justify-content: center;
      margin: 25px 0 15px 0;
    }

    .day-name {
      opacity: .3;
      color: #fff;
      background: #6a6a6a;
      font-size: 16px;
      border-radius: 14px;
      padding: 5px 16px 5px 16px;
    }

    .day-search-list {
      margin: 0;
      padding: 0 20px;
    }
  }
</style>
